import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

import { switcherStyle, SwitchStyled } from './Switcher.style';

type SwitcherPropType = {
  firstOption: string;
  secondOption: string;
  isSwitcherOn: boolean;
  setSwitcherOn: Dispatch<SetStateAction<boolean>>;
};

export const Switcher = ({ firstOption, secondOption, isSwitcherOn, setSwitcherOn }: SwitcherPropType) => {
  const handleSwitchChange = () => setSwitcherOn((prev) => !prev);
  const { i18n } = useTranslation();
  const switcherPositioning = i18n.language === 'en' ? 94 : i18n.language === 'de' ? 129 : 119;

  return (
    <Box sx={switcherStyle}>
      <Box sx={{ display: 'flex', alignItems: 'center', width: 'fit-content', margin: '0 auto' }}>
        <Typography sx={{ fontWeight: isSwitcherOn ? '400' : '700', marginRight: '64px' }}>{firstOption}</Typography>
        <Box sx={{ position: 'absolute', top: '14px', left: `${switcherPositioning}px` }}>
          {/* TODO: replace with reusable switch */}
          <SwitchStyled disableRipple checked={isSwitcherOn} onChange={handleSwitchChange} />
          {/* <Switch  checked={isSwitcherOn} onChange={handleSwitchChange} /> */}
        </Box>
        <Typography sx={{ fontWeight: isSwitcherOn ? '700' : '400' }}>{secondOption}</Typography>
      </Box>
    </Box>
  );
};
